import { render, staticRenderFns } from "./warehouseGoodsInfo.vue?vue&type=template&id=6c88e420&scoped=true&"
import script from "./warehouseGoodsInfo.vue?vue&type=script&lang=js&"
export * from "./warehouseGoodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./warehouseGoodsInfo.vue?vue&type=style&index=0&id=6c88e420&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c88e420",
  null
  
)

export default component.exports